import { createContext, DragEvent, useContext } from 'react';

import type { DraggableProvidedDragHandleProps } from '@/shared/components/drag-and-drop';

import type { NestedResourceSortableTabBarProps } from '.';

interface NestedResourceTabDragState {
    canDrag: boolean;
    dragHandleProps?: DraggableProvidedDragHandleProps | null;
    isDragging: boolean;
}

const NestedResourceTabDragContext = createContext<NestedResourceTabDragState | undefined>(undefined);

export const NestedResourceTabDragProvider = NestedResourceTabDragContext.Provider;

export const useNestedResourceTabDrag = () => useContext(NestedResourceTabDragContext);

export type NestedResourceTabDropEdge = 'before' | 'after';

export interface NativeNestedResourceTabDragState extends Pick<
    NestedResourceSortableTabBarProps,
    'allowReorder' | 'droppableId' | 'onDragEnd' | 'parentLocked' | 'resource' | 'resourceIds'
> {
    activeResourceId?: string;
    activeTabSize?: { gutter: number; height: number; width: number };
    cancelDrag: () => void;
    dropResource: (targetResourceId: string, edge: NestedResourceTabDropEdge) => void;
    dropTarget?: { edge: NestedResourceTabDropEdge; resourceId: string };
    previewResourceIds: string[];
    rtl: boolean;
    setDropTarget: (target?: { edge: NestedResourceTabDropEdge; resourceId: string }) => void;
    startDrag: (resourceId: string, event: DragEvent<HTMLElement>) => void;
}

const NativeNestedResourceTabDragContext = createContext<NativeNestedResourceTabDragState | undefined>(undefined);

export const NativeNestedResourceTabDragProvider = NativeNestedResourceTabDragContext.Provider;

export const useNativeNestedResourceTabDrag = () => useContext(NativeNestedResourceTabDragContext);
